import AppConfig from '../AppConfig';

export const PREVIEW_FAILURE = 'Failed to start lifecare preview generation.';

export const enrichPreviewFailureMessage = (message) =>
  /network/i.test(message) ? `${PREVIEW_FAILURE} (cannot reach PFQ at ${AppConfig.PfqBaseUrl})` : message;
